import { Controller } from '@hotwired/stimulus';
import { Modal } from 'bootstrap';

export default class extends Controller {
    static targets = ['modalBody'];

    declare readonly modalBodyTarget: HTMLElement;
    private modal: Modal | null = null;
    private boundClick!: (event: Event) => void;

    connect() {
        const el = document.getElementById('auditDetailModal');
        if (el) {
            this.modal = new Modal(el);
        }

        this.boundClick = (event: Event): void => {
            const button = (event.target as Element).closest<HTMLElement>('[data-audit-detail-id-param]');
            if (!button || !this.element.contains(button)) return;

            event.preventDefault();
            void this.load(
                Number(button.dataset.auditDetailIdParam),
                button.getAttribute('href') ?? undefined
            );
        };

        this.element.addEventListener('click', this.boundClick);
    }

    disconnect() {
        this.element.removeEventListener('click', this.boundClick);
        this.modal?.dispose();
    }

    async open(event: Event & { params: { id: number } }) {
        event.preventDefault();
        const link = event.currentTarget as HTMLAnchorElement | null;
        await this.load(event.params.id, link?.href);
    }

    private async load(id: number, url?: string): Promise<void> {
        if (!id || !this.modal) return;

        this.modalBodyTarget.innerHTML = '<div class="text-center py-4"><div class="spinner-border" role="status"></div></div>';
        this.modal.show();

        try {
            const response = await fetch(url ?? `/admin/audit-log/${id}/detail`);
            if (!response.ok) throw new Error('Error loading detail');
            this.modalBodyTarget.innerHTML = await response.text();
        } catch {
            this.modalBodyTarget.innerHTML = '<div class="alert alert-danger">Error al cargar el detalle</div>';
        }
    }
}
